import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logisticList } from '../../services/Api';

export const fetchLogistics = createAsyncThunk(
    'logistic/fetchLogistics',
    async (_, { getState }) => {
        try {
            const { filters } = getState().logistic;

            // Prepare parameters conditionally
            const params = {
                ...(filters.search && { name: filters.search }),
                ...(filters.from && { from: filters.from }),
                ...(filters.to && { to: filters.to }),
                ...(filters.status && { status: filters.status }),
                ...(filters.page && { page: filters.page }),
                ...(filters.paginate_per_page && { paginate_per_page: filters.paginate_per_page })
            };

            const response = await logisticList(params);
            return response;
        } catch (error) {
            throw error;
        }
    }
);

const initialState = {
    logistics: [],
    loading: false,
    error: null,
    shouldRefresh: false,
    pagination: {
        currentPage: 1,
        totalPage: 1,
        showing: 10,
        total: 0
    },
    filters: {
        from: '',
        to: '',
        search: '',
        status: '',
        sorting: 'desc',
        page: "1",
        paginate_per_page: "10"
    }
};

const logisticSlice = createSlice({
    name: 'logistic',
    initialState,
    reducers: {
        setShouldRefresh: (state, action) => {
            state.shouldRefresh = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        },
        // setPagination: (state, action) => {
        //     state.pagination = { ...state.pagination, ...action.payload };
        // }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogistics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLogistics.fulfilled, (state, action) => {
                state.loading = false;
                // state.logistics = action.payload.data?.map(item => ({
                //     ...item,
                //     status: item.status.toString()
                // })) || [];
                state.logistics = action.payload?.data || [];
                if (action.payload.meta) {
                    state.pagination = {
                        currentPage: action.payload.meta.current_page || 1,
                        totalPage: action.payload.meta.last_page || 1,
                        showing: action.payload.meta.per_page || 10,
                        total: action.payload.meta.total || 0
                    };
                }
            })
            .addCase(fetchLogistics.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.logistics = [];
            });
    }
});

// export const { setFilters, resetFilters, setPagination, setShouldRefresh } = logisticSlice.actions;
export const { setFilters, resetFilters, setShouldRefresh } = logisticSlice.actions;
export default logisticSlice.reducer;